angular.module('backstage.directives.externals', []);

require('./bsAnyFpTypeComboWidget');
require('./bsDefaultExternalComboWidget');
require('./bsTargetsAndExceptionsComboWidget');
require('./bsTargetsExceptionsFloatingRuleEditor');
require('./bsTargetsOrExceptionsTagList');
